import axios from 'axios'
import Cookies from 'js-cookie'

import { checkCloudflareChallenge, handleCloudflareChallenge } from '@api/axios-interceptors/cloudflare'
import { setTimezoneHeader } from '@api/axios-interceptors/timezone'

import { getServerMessage } from '@supplier/utils/errors'

const apiBaseURL = window.config?.api_url || ''

const supplierHttp = axios.create({
  baseURL: apiBaseURL,
  withCredentials: Boolean(apiBaseURL),
})

let unauthorizedHandler = () => false

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler
}

supplierHttp.interceptors.request.use((config) => {
  const token = Cookies.get('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return setTimezoneHeader(config)
})

supplierHttp.interceptors.response.use(
  async(response) => {
    if (!checkCloudflareChallenge(response)) return response
    return supplierHttp(await handleCloudflareChallenge(response.config))
  },
  async(error) => {
    if (axios.isCancel(error)) return Promise.reject(error)
    const { response } = error
    if (checkCloudflareChallenge(response)) return supplierHttp(await handleCloudflareChallenge(error.config))
    error.message = getServerMessage(error) || error.message
    if (response?.status === 401 && unauthorizedHandler(error)) return new Promise(() => {})
    return Promise.reject(error)
  },
)

export default supplierHttp
